(() => {
  const initialScrollSetting = window.getComputedStyle(document.documentElement).getPropertyValue('scroll-behavior');
  let timer;
  const temporarilySisableSmoothScrolling = () => {
    document.documentElement.style.scrollBehavior = 'auto';
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      document.documentElement.style.scrollBehavior = initialScrollSetting;
    }, 3000);
  };

  window.addEventListener('popstate', temporarilySisableSmoothScrolling);

  // deactivates smooth scrolling at the very start to reinstate it later
  // work for backward navigation
  if (window.swinger.navigation.isBackOrReloadNavigation) {
    temporarilySisableSmoothScrolling();
  }
})();
